<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div class="modal-body-container">
            <img :src="source"/>
            <CButton type="button" class="my-4 btn btn-primary align-self-center" @click="closeConfirmRequested">{{ $t('close') }}</CButton>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';

export default {
    extends: BasePopUp,
    components: {BasePopUp},
    methods:{
        closeConfirmRequested(event)
        {       
            this.$emit("closeConfirmRequested");
        }
    },
    props:{
        source:
        {
            type: String,
            default: ''
        },
    },
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    
    }

    img
    {
        max-width: 80vw;
        max-height: 80vh;
        object-fit: contain;
    }
</style>